import SystemManageArea from '@/global/components/system-area';
import './index.less';
import DisplayRightPanel from '@/panel/display-right';
import { useContext, useEffect, useRef, useState } from 'react';
import { AxisT, ModelBase, RenderMode, ToggleLayerHiddenCommand } from 'pytha';
import { SystemStatus } from '@/global/store/system-store';
import { SystemContext } from '@/App';
import { graphicStore } from '@/global/store/graphic-store';
import localStore, { LOCAL_USER_TYPE, PROJECT_LIST } from '@/global/store/local-store';
import genUUID from '@/global/utils/gen-uuid';
import { ModelsInArchiBase } from '@/passets/archibase-engine/models';
import { cmdRegister } from '@/routes/tab-routes/draw/cmd-register';
import Viewport from '@/routes/tab-routes/draw/viewport';
import { useParams, useLocation } from 'react-router';
import { Scene, AmbientLight, Color, CanvasTexture, SpriteMaterial, Sprite, Vector3 } from 'three';
import { findPrimitivesInGraphic } from '@/api/geometry/primitive';
import { Primitive } from '@/global/interface/primitive';
import { initProject } from '@/api/project-manage/project';
import { findGlobalUcs, findUcsInProject } from '@/api/geometry/ucs';
import { Ucs } from '@/global/interface/ucs';
import { Layer } from '@/global/interface/layer';
import { createMonitorSpriteCanvas, createSpriteCanvas } from '@/global/utils/sprite-utils';
import { getMonitorObjectEntitiesByProjectId } from '@/api/monitor-object/monitor-object';
import { getSensorByPrimitiveUuid } from '@/api/device/sensor';
import { Sensor } from '@/global/interface/device/sensor';
import { OnlySelectStrategy } from '@/passets/archibase-engine/controls/OnlySelectControl';
import { TINY_SELECT_STRATEGY_TYPE } from '@/passets/archibase-engine/enums/select-type';
import TnMessage from '@/global/components/message';
import { useNavigate } from 'react-router-dom';
import CryptoJS from 'crypto-js';
import { USER_TYPE } from '@/enums/user';
import { Emit_Event } from '@/enums/emit-event';
import { emitter } from '@/global/listeners';
import { LayerType } from '@/enums/layer-type';
import { ModelsInBimCommon } from 'tnbimbase';
import { MonitorObjectEntity } from '@/global/interface/monitor-object/monitor-object';
import { message } from 'antd';
import { collectPrimitiveLoadStat, formatBytes, formatCost, } from '@/global/utils/primitive-load-stat';

const ShowBtnIndex = {
    SHOW_NONE: 0,
    SHOW_DEVICE: 1,
    SHOW_MONITOR: 2
}


export default function LargeScreenMain() {
    const { projectId } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const [sceneUpdate, setSceneUpdate] = useState<string>(''); // 场景更新的信号
    const [finishInit, setFinishInit] = useState<boolean>(false);
    const [visiable, setVisiable] = useState<boolean>(true);
    const systemContext = useContext<SystemStatus>(SystemContext);
    // 设备编号与检测对象按钮按下index，0都不按下，1设备编号，2检测对象
    const [selectBtnIndex, setSelectBtnIndex] = useState<number>(ShowBtnIndex.SHOW_NONE)
    const imgRef = useRef(null);
    const [monitorObjectList, setMonitorObjectList] = useState<MonitorObjectEntity[]>([])
    const [showDevice, setShowDevice] = useState<boolean>(false);   // 是否显示设备
    // Alt 连击状态
    const altPressRef = useRef<{ count: number; lastTime: number; }>({
        count: 0,
        lastTime: 0,
    });

    /**
     * 连续按 5 次 Alt，显示当前项目图元加载接口大小和耗时。
     */
    useEffect(() => {
        const handleKeyDown = (
            event: KeyboardEvent,
        ) => {
            const isAltKey =
                event.key === 'Alt' ||
                event.code === 'AltLeft' ||
                event.code === 'AltRight';

            if (!isAltKey) {
                return;
            }

            /**
             * 按住 Alt 时浏览器会自动重复触发 keydown，
             * 这种重复事件不能算作多次按键。
             */
            if (event.repeat) {
                return;
            }

            /**
             * 防止 Alt 激活浏览器菜单栏。
             */
            event.preventDefault();

            const now = Date.now();
            const maxInterval = 2500;

            /**
             * 与上一次 Alt 间隔超过 2.5 秒，
             * 重新从第一次开始计数。
             */
            if (
                !altPressRef.current.lastTime ||
                now -
                altPressRef.current.lastTime >
                maxInterval
            ) {
                altPressRef.current = {
                    count: 1,
                    lastTime: now,
                };

                return;
            }

            const nextCount =
                altPressRef.current.count + 1;

            altPressRef.current = {
                count: nextCount,
                lastTime: now,
            };

            if (nextCount < 5) {
                return;
            }

            /**
             * 达到 5 次后立刻重置。
             */
            altPressRef.current = {
                count: 0,
                lastTime: 0,
            };

            if (!projectId) {
                message.info(
                    '暂无当前项目信息',
                );

                return;
            }

            const info =
                localStore
                    .getScreenPrimitiveLoadInfo(
                        projectId,
                    );

            if (!info) {
                message.info(
                    '暂无当前项目图元加载统计信息',
                );

                return;
            }

            const projectName =
                info.projectName ||
                localStore.getProjectName() ||
                '当前项目';

            const sizeText =
                formatBytes(
                    info.sizeBytes,
                );

            const costText =
                formatCost(
                    info.requestCostMs,
                );

            message.info(
                `${projectName}图元加载接口大小${sizeText}，耗时${costText}`,
            );
        };

        window.addEventListener(
            'keydown',
            handleKeyDown,
            true,
        );

        return () => {
            window.removeEventListener(
                'keydown',
                handleKeyDown,
                true,
            );
        };
    }, [projectId]);

    useEffect(() => {
        // 验证，无项目跳转到项目列表
        if (!projectId) {
            navigate("/desktop/project-list");
        }
        if (localStore.get(LOCAL_USER_TYPE) === CryptoJS.MD5(USER_TYPE.ADMIN.toString()).toString()) {
            return;
        }
        if (!localStore.get(PROJECT_LIST)?.some(item => item === +projectId)) {
            // 该用户不在该项目中，弹出到项目列表
            TnMessage.destory();
            TnMessage.error("您无权进入该项目");
            navigate("/desktop/project-list")
        }
    }, [projectId])

    useEffect(() => {
        emitter.on(Emit_Event.TOGGLE_COMPASS, toggleCompassLayer)
        return (() => {
            emitter.off(Emit_Event.TOGGLE_COMPASS, toggleCompassLayer)
        })
    }, [])

    // 控制指北针显示隐藏
    const toggleCompassLayer = () => {
        if (!graphicStore?.context?.layerContext) return;
        if (!graphicStore?.extraContext?.getCurrentViewEditor()) return;
        // 1 判断指北针图层是否存在
        let compassLayer: Layer = graphicStore?.context?.layerContext?.layers?.find(item => item.type === LayerType.COMPASS);
        if (!compassLayer) return;
        new ToggleLayerHiddenCommand(compassLayer, !compassLayer.hidden).execute();
        graphicStore?.extraContext?.getCurrentViewEditor()?.listeners.signals.needRender.dispatch('redraw');
    }


    useEffect(() => {
        setVisiable(true);
        if (imgRef.current) {
            let timer = setTimeout(() => {
                imgRef?.current?.classList?.add('visible');
                clearInterval(timer);
            }, 100)
        }
    }, [projectId, location])

    useEffect(() => {
        if (!finishInit) return;
        let timer = setTimeout(() => {
            setVisiable(false);
        }, 500)

        return () => {
            clearInterval(timer);
        }
    }, [finishInit])

    const initScene = () => {
        return new Promise((resolve, reject) => {
            if (graphicStore.extraContext.sceneContext.scene == null) {
                let scene = new Scene();

                // 在初始化部分添加光源
                // 添加光照
                const ambientLight = new AmbientLight(0xffffff, 1);
                scene.add(ambientLight);

                // const directionalLight = new DirectionalLight(0xffffff, 0.8);
                // directionalLight.position.set(1, 1, 1).normalize();
                // directionalLight.castShadow = true; // 使光源投射阴影
                // scene.add(directionalLight);

                // const directionalLight1 = new DirectionalLight(0xffffff, 0.6);
                // directionalLight1.position.set(-1, 1, 1).normalize();
                // directionalLight1.castShadow = true; // 使光源投射阴影
                // scene.add(directionalLight1);
                graphicStore.extraContext.sceneContext.scene = scene;
                setSceneUpdate(genUUID());
                resolve(1);
            }
        })
    }

    useEffect(() => {
        // 将命令api注册到图形库中
        cmdRegister();
    }, [])

    useEffect(() => {
        if (!projectId) {
            localStore.projectId = null;
            return () => { };
        }

        localStore.projectId = projectId;
        initScene();
        document.oncontextmenu = () => {
            return false;
        }
        if (graphicStore?.context) {
            Object.keys(ModelsInArchiBase).forEach(type => {
                graphicStore.context.modelContext.addEntitytoCtrl(type);
                graphicStore.context.modelContext.registerModel(type, ModelsInArchiBase[type]);
            })
            if (graphicStore.context) {
                Object.keys(ModelsInBimCommon).forEach(type => {
                    graphicStore.context.modelContext.addEntitytoCtrl(type);
                    graphicStore.context.modelContext.registerModel(type, ModelsInBimCommon[type]);
                })
            }
        }
        // 模型变化，更新数据
        generateData();
        window.addEventListener('resize', onWindowResize);
        // 初始化按钮类型
        setSelectBtnIndex(0)
        return (() => {
            window.removeEventListener('resize', onWindowResize);
            graphicStore.extraContext.sceneContext.scene.clear();
            graphicStore.extraContext.sceneContext.scene = null;
        })
    }, [projectId])

    const onWindowResize = () => {
        graphicStore.extraContext.listeners?.signals.windowResize.dispatch();
    }

    const generateData = () => {

        setFinishInit(false);
        if (!projectId) return;
        // 设置世界坐标的默认颜色
        graphicStore.context.renderContext.axisColor.set(new Color(0, 0, 0))
        // 设置鼠标默认颜色
        graphicStore.context.renderContext.cusorColor.set(new Color(0, 0, 1))
        // 设置渲染模式
        graphicStore.context.renderContext.renderType = RenderMode.CONCEPT
        initProjectInfo().then((_) => {
            return initUcs();
        }).then((_) => {
            return initModels();
        }).catch(error => {
            console.error(
                '[LARGE_SCREEN_INIT][ERROR]',
                error,
            );
        }).finally(() => {
            graphicStore.extraContext.getCurrentViewEditor()?.showAllEntities(true);
            // TODO 全局设置
            graphicStore.context.renderContext.gridLineDistanceToCircle = 3000;
            graphicStore.context.renderContext.textHeight = 300;
            graphicStore.extraContext.listeners.signals.onEditStatusChanged.dispatch();

            graphicStore.extraContext.getCurrentViewEditor()?.viewCube.prepareAnimationData("vb");
            if (graphicStore?.extraContext?.getCurrentViewEditor()) {
                graphicStore.extraContext.getCurrentViewEditor().viewCube.animating = true;

                // 关掉夹点显示
                graphicStore.extraContext.getCurrentViewEditor().clampControl.enabled = false;
                graphicStore.extraContext.getCurrentViewEditor().clampControl.hidden = true;
                // 不渲染光标
                graphicStore.extraContext.getCurrentViewEditor().cursorControl.needRenderCursor = false;

                // 重新注册选择控制器
                graphicStore.extraContext.getCurrentViewEditor().selectControl.updateStrategy(OnlySelectStrategy, TINY_SELECT_STRATEGY_TYPE.ONLY_SELECT)
                setFinishInit(true)

                setTimeout(() => {
                    graphicStore.extraContext.getCurrentViewEditor()?.showAllEntities(true);
                }, 500)
            }
        })
    }
    const initProjectInfo = () => {
        return new Promise((resolve, reject) => {
            initProject(projectId).then(res => {
                if (res.status === 200) {
                    localStore.projectId = projectId;
                    resolve(1);
                }
            })
        })
    }

    const initUcs = () => {
        return new Promise((resolve, reject) => {
            findUcsInProject(projectId).then(res => {
                let jsonList: Ucs[] = res.data || [];
                let ucsList = [];
                jsonList.forEach((json) => {
                    if (json.isWcs) return;
                    let ucs: AxisT = new AxisT().fromJson(json);
                    ucsList.push(ucs);
                });
                findGlobalUcs(projectId).then(res => {
                    let json = res.data;
                    let wcs = new AxisT().fromJson(json);
                    if (wcs != null) {
                        ucsList.push(wcs);
                    }
                    if (wcs == null && ucsList.length > 0) wcs = ucsList[0];
                    graphicStore.context.ucsContext.setUcsList(ucsList);
                    graphicStore.context.ucsContext.setCurrentUcs(wcs);
                    if (wcs != null) {
                        let viewObj = wcs.render();
                        graphicStore.extraContext.sceneContext.scene?.add(viewObj);
                    }
                    resolve(1);
                })
            })
        })
    }


    /**
     * 加载项目图元，并统计图元接口大小、耗时。
     */
    const initModels = () => {
        return new Promise<number>((resolve, reject) => {
            if (!projectId) {
                resolve(1);
                return;
            }

            // 固定本次请求所属项目，避免请求过程中切换项目
            const currentProjectId = projectId;

            // 图元接口开始时间
            const loadStartTime = performance.now();

            // console.log(
            //     '[PRIMITIVE_LOAD_STAT][START]',
            //     {
            //         projectId: currentProjectId,
            //         loadStartTime,
            //     },
            // );

            findPrimitivesInGraphic(currentProjectId)
                .then(res => {
                    // 图元接口响应结束时间
                    const loadEndTime =
                        performance.now();

                    const jsonList: Primitive[] =
                        res?.data || [];

                    const stat =
                        collectPrimitiveLoadStat({
                            projectId:
                                currentProjectId,

                            loadStartTime,
                            loadEndTime,

                            // 后端完整 StdResult
                            responseData: res,

                            primitiveCount:
                                jsonList.length,
                        });

                    // 接口返回后立即保存大小、耗时
                    localStore
                        .setScreenPrimitiveLoadInfo(
                            currentProjectId,
                            {
                                projectName:
                                    localStore
                                        .getProjectName() ||
                                    '',

                                sizeBytes:
                                    stat.sizeBytes,

                                sizeSource:
                                    stat.sizeSource,

                                requestCostMs:
                                    stat.requestCostMs,

                                requestUrl:
                                    stat.requestUrl,

                                primitiveCount:
                                    stat.primitiveCount,
                            },
                        );

                    // console.log(
                    //     '[PRIMITIVE_LOAD_STAT][SAVED]',
                    //     {
                    //         projectId:
                    //             currentProjectId,
                    //         ...stat,
                    //         storedInfo:
                    //             localStore
                    //                 .getScreenPrimitiveLoadInfo(
                    //                     currentProjectId,
                    //                 ),
                    //     },
                    // );

                    /**
                     * 以下部分尽量保持原始图元加载逻辑不变。
                     */
                    if (
                        graphicStore.extraContext
                            .getCurrentViewEditor()
                    ) {
                        // 清空广告牌
                        clearSprite();

                        // 清空监测对象列表
                        clearMonitor();

                        const entities = jsonList.map(
                            (json: Primitive) => {
                                const ModelConstructor =
                                    graphicStore.context
                                        .modelContext
                                        .getModelConstructor(
                                            json.properties
                                                .type,
                                        );

                                if (
                                    ModelConstructor
                                ) {
                                    const entity:
                                        ModelBase =
                                        new ModelConstructor();

                                    entity.fromJson(
                                        json.properties,
                                    );

                                    if (
                                        entity?.type ===
                                        'AnemoclinographT' ||
                                        entity?.type ===
                                        'MonitorT' ||
                                        entity?.type ===
                                        'FluviographT'
                                    ) {
                                        initPrite(entity);
                                    }

                                    return entity;
                                }

                                // console.log(
                                //     'no match primitive type',
                                //     json.properties.type,
                                // );

                                return undefined;
                            },
                        );

                        graphicStore.extraContext
                            .getCurrentViewEditor()
                            .addObjects(entities);
                    }

                    resolve(1);
                })
                .catch(error => {
                    console.error(
                        '[PRIMITIVE_LOAD_STAT][ERROR]',
                        {
                            projectId:
                                currentProjectId,

                            costMs:
                                performance.now() -
                                loadStartTime,

                            error,
                        },
                    );

                    reject(error);
                });
        });
    };

    const clearSprite = () => {
        if (graphicStore.spriteMap) {
            for (let uuid in graphicStore.spriteMap) {
                let spriteItem = graphicStore.spriteMap[uuid]
                if (spriteItem.sprite?.parent) {
                    spriteItem.sprite.parent.remove(spriteItem.sprite)
                }
                delete graphicStore.spriteMap[uuid]
            }
        }
    }

    const clearMonitor = () => {
        let entityUuids = monitorObjectList.map((item: MonitorObjectEntity) => {
            return item.entity.uuid;
        });
        if (!!graphicStore.extraContext.getCurrentViewEditor()) {
            graphicStore.extraContext.getCurrentViewEditor().removeObjectByUuids(entityUuids);
        }
        setMonitorObjectList([])
    }

    const initPrite = (entity: ModelBase) => {
        // 获取设备名称
        getSensorByPrimitiveUuid(entity.uuid).then(res => {
            let sensor: Sensor = res.data
            if (sensor == null) return;
            const spriteTexture = new CanvasTexture(createSpriteCanvas(sensor.code))
            const spriteMaterial = new SpriteMaterial({
                map: spriteTexture,
                transparent: true,
                alphaTest: 0.5 // 丢弃 alpha 值小于 0.5 的像素
            })
            const sprite = new Sprite(spriteMaterial)
            sprite.scale.set(100 + (sensor?.code?.length || 0) * 100, 300, 1)
            let box = entity.getBoundingBox()
            sprite.position.set(
                (box.max.x + box.min.x) / 2,
                (box.max.y + box.min.y) / 2,
                box.max.z + 300
            )
            graphicStore.spriteMap[entity.uuid] = { sprite: sprite, text: sensor.code, isMonitor: false, isSelect: false }
        })
    }

    const initMonitorPrite = (entity: ModelBase, name: string) => {
        const spriteTexture = new CanvasTexture(createMonitorSpriteCanvas(name))
        const spriteMaterial = new SpriteMaterial({
            map: spriteTexture,
            transparent: true,
            alphaTest: 0.5, // 丢弃 alpha 值小于 0.5 的像素
        })
        const sprite = new Sprite(spriteMaterial)
        sprite.scale.set(100 + name.length * 100, 1250, 1)
        let center: Vector3 = new Vector3()
        entity.getCenter(center)
        sprite.position.set(
            center.x,
            center.y,
            center.z
        )
        graphicStore.spriteMap[entity.uuid] = { sprite: sprite, text: name, isMonitor: true, isSelect: false }
    }

    useEffect(() => {
        if (selectBtnIndex == 0) {
            disShowDeviceCode()
            disShowMonitorObjectEntities()
        } else if (selectBtnIndex == 1) {
            showDeviceCodeChange()
            disShowMonitorObjectEntities()
        } else if (selectBtnIndex == 2) {
            disShowDeviceCode()
            showMonitorObjectEntities()
        }
        graphicStore?.extraContext?.getCurrentViewEditor()?.listeners?.signals?.needRender.dispatch('redraw');
    }, [selectBtnIndex])

    // 关闭监测对象图元
    const disShowMonitorObjectEntities = () => {
        if (monitorObjectList?.length > 0) {
            let entityUuids = monitorObjectList.map((item: MonitorObjectEntity) => {
                return item.entity.uuid;
            });
            if (!!graphicStore.extraContext.getCurrentViewEditor()) {
                graphicStore.extraContext.getCurrentViewEditor().removeObjectByUuids(entityUuids);
            }
            for (let i = 0; i < entityUuids.length; i++) {
                if (graphicStore.spriteMap[entityUuids[i]]) {
                    if (graphicStore.spriteMap[entityUuids[i]].sprite.parent) {
                        graphicStore.spriteMap[entityUuids[i]].sprite.parent.remove(graphicStore.spriteMap[entityUuids[i]].sprite)
                    }
                }
            }
        } else {
            getMonitorObjectEntitiesByProjectId(+projectId).then(res => {
                let list: MonitorObjectEntity[] = res.data || [];
                let entityUuids = list.map((item: MonitorObjectEntity) => {
                    return item.entity.uuid;
                });
                if (!!graphicStore.extraContext.getCurrentViewEditor()) {
                    graphicStore.extraContext.getCurrentViewEditor().removeObjectByUuids(entityUuids);
                }
                setMonitorObjectList(list)
            })
        }

    }

    // 显示监测对象图元
    const showMonitorObjectEntities = () => {
        if (monitorObjectList?.length > 0) {
            let entities = monitorObjectList.map((item: MonitorObjectEntity) => {
                let entity: ModelBase = new (graphicStore.context.modelContext.getModelConstructor(item.entity.type))();
                entity.fromJson(item.entity);
                entity.positionUpdateCallBack = true;
                entity.extraData = { monitorObjectId: item.monitorObjectId };
                if (!graphicStore.spriteMap[entity.uuid]) {
                    initMonitorPrite(entity, item?.name || "对象")
                }
                return entity;
            });
            if (!!graphicStore.extraContext.getCurrentViewEditor()) {
                const editor = graphicStore.extraContext.getCurrentViewEditor();
                let showEntities = [];
                entities.forEach(entity => {
                    if (!editor.entityDict[entity.uuid]) {
                        showEntities.push(entity);
                    }

                })
                graphicStore.extraContext.getCurrentViewEditor().addObjects(showEntities);
            }
        } else {
            getMonitorObjectEntitiesByProjectId(+projectId).then(res => {
                let list: MonitorObjectEntity[] = res.data || [];
                setMonitorObjectList(list)
                let entities = list.map((item: MonitorObjectEntity) => {
                    let entity: ModelBase = new (graphicStore.context.modelContext.getModelConstructor(item.entity.type))();
                    entity.fromJson(item.entity);
                    entity.positionUpdateCallBack = true;
                    entity.extraData = { monitorObjectId: item.monitorObjectId };
                    if (!graphicStore.spriteMap[entity.uuid]) {
                        initMonitorPrite(entity, item?.name || "对象")
                    }
                    return entity;
                });
                if (!!graphicStore.extraContext.getCurrentViewEditor()) {
                    const editor = graphicStore.extraContext.getCurrentViewEditor();
                    let showEntities = [];
                    entities.forEach(entity => {
                        if (!editor.entityDict[entity.uuid]) {
                            showEntities.push(entity);
                        }
                    })
                    graphicStore.extraContext.getCurrentViewEditor().addObjects(showEntities);
                }
            })
        }

    }

    // 显示设备编号
    const showDeviceCodeChange = () => {
        let spriteMap = graphicStore.spriteMap
        for (let uuid in spriteMap) {
            let spriteItem = spriteMap[uuid]
            if (spriteItem.isMonitor) continue;
            graphicStore.extraContext.sceneContext.scene.add(spriteItem.sprite)
        }
    }

    // 隐藏设备编号
    const disShowDeviceCode = () => {
        let spriteMap = graphicStore.spriteMap
        for (let uuid in spriteMap) {
            let spriteItem = spriteMap[uuid]
            if (spriteItem.isMonitor) continue;
            if (spriteItem.sprite.parent && !spriteItem.isSelect) {
                spriteItem.sprite.parent.remove(spriteItem.sprite)
            }
        }
    }

    return (
        <div className="large-screen-container">
            <div className='system-manager'>
                {/* TODO 大屏不用这个样式 */}
                <SystemManageArea showDevice={showDevice} onChangeShowDevice={setShowDevice} />
            </div>
            <div className='main'>
                <div className='draw'>
                    <Viewport
                        needCube={false}
                        sceneUpdate={sceneUpdate}
                        viewportId='viewport'
                        viewHelperId='viewHelper-1'
                        cameraType={systemContext?.currentCameraType}
                        isDisplay={true}
                        toolBtnIndex={selectBtnIndex}
                        setToolBtnIndex={setSelectBtnIndex}
                    />
                </div>
                <DisplayRightPanel finishInit={finishInit} showPriceType={selectBtnIndex} showDevice={showDevice} onChangeShowDevice={setShowDevice} />
                {/* <div className='btn-area'>
                    <div className={classNames({
                        "btn-item": true,
                        "btn-item-active": selectBtnIndex == ShowBtnIndex.SHOW_DEVICE
                    })}
                        onClick={() => {
                            if (selectBtnIndex == ShowBtnIndex.SHOW_DEVICE) {
                                setSelectBtnIndex(ShowBtnIndex.SHOW_NONE)
                            } else {
                                setSelectBtnIndex(ShowBtnIndex.SHOW_DEVICE)
                            }
                        }}
                    >
                        {selectBtnIndex == ShowBtnIndex.SHOW_DEVICE ? <NoSelectSvg style={{ width: "16px", height: "16px" }} /> : <NoSvg style={{ width: "16px", height: "16px" }} />}
                        设备编号
                    </div>
                    <div className={classNames({
                        "btn-item": true,
                        "btn-item-active": selectBtnIndex == ShowBtnIndex.SHOW_MONITOR
                    })} onClick={() => {
                        if (selectBtnIndex == ShowBtnIndex.SHOW_MONITOR) {
                            setSelectBtnIndex(ShowBtnIndex.SHOW_NONE)
                        } else {
                            setSelectBtnIndex(ShowBtnIndex.SHOW_MONITOR)
                        }
                    }}>
                        {selectBtnIndex == ShowBtnIndex.SHOW_MONITOR ? <MonitorSelectSvg style={{ width: "16px", height: "16px" }} /> : <MonitorSvg style={{ width: "16px", height: "16px" }} />}
                        监测对象
                    </div>
                </div>

                {/* <div className={`fade-box ${visible ? 'visible' : 'hidden'}`}
                    onTransitionEnd={() => setVisible(false)}>
                    <div className="logo-area"><img width={800} height={400} src="/logo.gif" /></div>
                </div> */}
            </div>
            <div className={`fade-box ${visiable ? 'visible' : 'hidden'}`}>
                <div className={`logo-area ${visiable ? 'visible' : 'hidden'}`}>
                    <img ref={imgRef} className={`img-area`} width={800} height={400} src="/logo.png" />
                </div>
            </div>
            {/* <MaskLoadingModal
                visible={loading}
                height='70px'
                loadingTip={loadingTip}
            /> */}
            {/* <Modal
                open={loading}
                destroyOnClose
                footer={null}
                closable={null}
                closeIcon={null}
                wrapClassName='gif-modal'
                width={416}
            >
                <img
                    width={416}
                    height={240}
                    src="/giflogo.gif"
                />
            </Modal> */}
        </div>
    )
}